// Schedule non-critical work for after the browser is idle (i.e. after first
// paint / interactive), so boot-time work — marketing-SDK init, fingerprint
// warm-ups — doesn't steal main-thread time or bandwidth from the critical
// render. Uses requestIdleCallback where available, else a setTimeout fallback
// (Safari < 16.4, jsdom).
//
// - `timeout` caps how long the idle wait may defer the callback so it still
//   runs on a persistently busy page.
// - `fallbackDelayMs` is the setTimeout delay used only when requestIdleCallback
//   is unavailable. Keep it near-immediate (default) for cheap work; pass a
//   larger value for heavy synchronous work that must clear first render on
//   those browsers (see preloadDeviceId's fingerprint warm-up).
export const onIdle = (
  cb: () => void,
  {
    timeout = 3000,
    fallbackDelayMs = 1,
  }: { timeout?: number; fallbackDelayMs?: number } = {},
): void => {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    window.requestIdleCallback(cb, { timeout })
  } else {
    setTimeout(cb, fallbackDelayMs)
  }
}
